import {
	HttpEvent,
	HttpHandlerFn,
	HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SupportContextService } from 'app/core/auth/support-context.service';
import { UserService } from 'app/core/user/user.service';
import { API_BASE_URL } from 'app/core/services/api.service';

export const supportContextInterceptor = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
	const supportContextService = inject(SupportContextService);
	const userService = inject(UserService);
	const apiBaseUrl = inject(API_BASE_URL, { optional: true });
	const context = supportContextService.context();
	const user = userService.userSig$();

	if (!user) {
		return next(req);
	}

	const canUseDelegation = userService.hasPermission('admin:global:dev');
	if (!canUseDelegation) {
		if (context) {
			supportContextService.clearContext();
		}
		return next(req);
	}

	if (!context || !isBackendRequest(req.url, apiBaseUrl)) {
		return next(req);
	}

	const setHeaders: Record<string, string> = {
		'X-CM-Act-As-UserId': `${context.actAsUserId}`,
	};

	if (context.actAsCustomerId) {
		setHeaders['X-CM-Act-As-CustomerId'] = `${context.actAsCustomerId}`;
	}

	if (context.reason) {
		setHeaders['X-CM-Act-As-Reason'] = context.reason;
	}

	if (context.ticketId) {
		setHeaders['X-CM-Act-As-TicketId'] = context.ticketId;
	}

	return next(
		req.clone({
			setHeaders,
		})
	);
};

function isBackendRequest(url: string, apiBaseUrl?: string | null): boolean {
	if (!url) {
		return false;
	}

	// Relative URLs are application backend calls in this app.
	if (!/^https?:\/\//i.test(url)) {
		return true;
	}

	try {
		const requestUrl = new URL(url);

		if (apiBaseUrl) {
			const apiOrigin = new URL(apiBaseUrl).origin;
			return requestUrl.origin === apiOrigin;
		}

		return requestUrl.origin === window.location.origin;
	} catch {
		return false;
	}
}
